import { z } from "zod";

/**
 * What the shopper is told when the agent hands the conversation to the retailer's team
 * (escalate_to_human). The agent passes it on in the shopper's language.
 */
export const handoffSchema = z
	.object({
		message: z
			.string()
			.trim()
			.min(1)
			.max(300)
			.default(
				"A member of our team will reply here as soon as they can.",
			),
		/** When the team answers, e.g. "every day from 9 am to 10 pm". Said only when set. */
		hoursText: z.string().trim().max(120).optional(),
	})
	.prefault({});
